import { useContext } from 'react'
import { FeatureFlagsContext } from './FeatureFlagsProvider'
import type { FeatureFlags } from './types'

export function useFeatureFlagsContext<F extends string>() {
  const featureFlags = useContext<FeatureFlags<F> | undefined>(FeatureFlagsContext)

  if (featureFlags === undefined) {
    throw new Error('useFeatureFlagsContext must be used within a FeatureFlagsProvider')
  }

  return { featureFlags }
}
